import { Dispatch } from "@reduxjs/toolkit";
import { clearCustomer, setCustomer } from "@/redux/ducks/customer";
import { clearUser } from "@/redux/ducks/user";
import { ReducersTypes } from "@/redux/reducers/Models";

export function expireClientSession(
  dispatch: Dispatch,
  getState: () => ReducersTypes,
): void {
  const customer = getState().customerReducer;
  dispatch(clearCustomer());
  dispatch(setCustomer({ username: customer?.username }));
  dispatch(clearUser());
}
